module.exports = __webpack_public_path__ + "static/logo-blue-girl-19041fc07f765b9c92b07f735cc35b76.png";